<template>
  <div class="vx-row">
    <vs-col vs-lg="12" vs-md="12" vs-sm="12" class="vx-col mb-4">
      <div class="vx-row">
        <vs-col vs-w="12" class="vx-col">
          <span>CPF:</span>
        </vs-col>
        <vs-col vs-w="12" class="vx-col">
          <cpf-input
            class="w-full"
            name="cpf"
            autocomplete="off"
            v-model="usuario.cpf"
            v-validate="'required|cpf'"
          />
          <span class="text-danger text-sm" v-show="errors.has('cpf')">{{ errors.first('cpf') }}</span>
        </vs-col>
      </div>
    </vs-col>
    <vs-col vs-lg="12" vs-md="12" vs-sm="12" class="vx-col mb-6 readonly-hidden">
      <div class="vx-row">
        <vs-col vs-w="12" class="vx-col">
          <span>Nova senha:</span>
        </vs-col>
        <vs-col vs-w="12" class="vx-col">
          <vs-input
            ref="password"
            name="password"
            autocomplete="off"
            type="password"
            class="w-full"
            v-model="usuario.password"
            v-validate="{required: passwordIsRequired}"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('password')"
          >{{ errors.first('password') }}</span>
        </vs-col>
      </div>
    </vs-col>
    <vs-col vs-lg="12" vs-md="12" vs-sm="12" class="vx-col mb-4 readonly-hidden">
      <div class="vx-row">
        <vs-col vs-w="12" class="vx-col">
          <span>Confirmar nova senha:</span>
        </vs-col>
        <vs-col vs-w="12" class="vx-col">
          <vs-input
            name="password_confirmation"
            type="password"
            class="w-full"
            autocomplete="off"
            v-validate="{required: passwordIsRequired, confirmed: 'password'}"
            v-model="usuario.password_confirmation"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('password_confirmation')"
          >{{ errors.first('password_confirmation') }}</span>
        </vs-col>
      </div>
    </vs-col>
  </div>
</template>

<script>
import CpfInput from "@/components/inputs/CpfInput.vue";
export default {
  name: "editar-dados-acesso",
  props: ["value"],
  inject: ["$validator"],
  components: { CpfInput },
  data() {
    return {
      usuario: {
        id: null
      },
      passwordIsRequired: false
    };
  },
  created() {
    if (this.$route.name === "cadastrar-usuario") {
      this.passwordIsRequired = true;
    }
  },
  watch: {
    value(usuario, oldUsuario) {
      if (usuario.id !== oldUsuario.id) {
        this.usuario = usuario;
      }
    },
    usuario: {
      handler(usuario) {
        let input = {
          id: usuario.id,
          cpf: usuario.cpf
        };
        if (usuario.password) {
          input.password = usuario.password;
          input.password_confirmation = usuario.password_confirmation;
        }
        this.$emit("input", input);
      },
      deep: true
    }
  }
};
</script>



